<template lang="html">

  <article class="observacion">
    <p class="status">{{data.titulo}}</p>
    <p class="line" v-if="!!data.autor">Autor: {{data.autor}}</p>
    <p class="line" v-if="!!data.tipoSeguimiento || !!data.accion">{{data.tipoSeguimiento}} {{(!!data.tipoSeguimiento && !!data.accion) ? "/" : ""}} {{data.accion}}</p>
    <p class="observacion-text" v-if="data.texto" v-html="data.texto"></p>
    <arrow-link class="lnk-adjunto" :text="'Ver Adjunto'" :external="true" :to="data.urlArchivo" :blank="true" v-if="!!data.urlArchivo"></arrow-link>
    <p class="fecha">{{data.fecha}}</p>
  </article>

</template>

<script lang="js">

  import arrowlink  from '@/components/parts/icons/arrow-link';

  export default  {
    name: 'observacion-manual-el',
    props: ['data'],
    components : {
      'arrow-link' : arrowlink,
    }
  }
</script>

<style scoped lang="scss">
    
    .observacion{
      width: 100%;
      display: inline-block;
      text-align: left;
      margin-bottom: 10px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 10px;

      .line{
        font-size: 14px;
        margin-bottom: 5px;
      }

      .fecha{
        font-size: 14px;
        margin-bottom: 10px;
      }
      
      .status{
        font-size: 12px;
        text-transform: uppercase;
        display: inline-block;
        font-weight: 700;
        margin-bottom: 5px;
      }

      .observacion-text{
        font-size: 14px;
        width: 100%;
        text-align: left;
        margin-bottom: 5px;
      }

      .lnk-adjunto{
        margin-top: -4px;
      }

      *:last-of-type{
        margin-bottom: 0;
      }

    }

</style>



// WEBPACK FOOTER //
// src/components/parts/observacion-manual-el.vue